
import { useState, useEffect } from 'react'
import Form from 'react-bootstrap/Form'
import InputGroup from "react-bootstrap/InputGroup"
import { RgbaColorPicker } from "react-colorful"
import Button from 'react-bootstrap/Button'

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

function rgbaToHex(r, g, b, a = 1) {
    // Clamp values to proper range
    r = Math.max(0, Math.min(255, r));
    g = Math.max(0, Math.min(255, g));
    b = Math.max(0, Math.min(255, b));
    a = Math.max(0, Math.min(1, a));

    // Convert to hex
    const toHex = (n) => n.toString(16).padStart(2, '0');
    const alphaHex = toHex(Math.round(a * 255));

    return `#${toHex(r)}${toHex(g)}${toHex(b)}${a < 1 ? alphaHex : ''}`;
}

function hexToRgba(hex) {
    // Remove '#' if present
    hex = hex.replace(/^#/, '');

    // Expand shorthand hex (#abc or #abcd) to full form
    if (hex.length === 3 || hex.length === 4) {
        hex = hex.split('').map(c => c + c).join('');
    }

    let r = parseInt(hex.slice(0, 2), 16);
    let g = parseInt(hex.slice(2, 4), 16);
    let b = parseInt(hex.slice(4, 6), 16);
    let a = 1.0;

    // Handle 8-digit hex (with alpha)
    if (hex.length === 8) {
        a = parseInt(hex.slice(6, 8), 16) / 255;
    }

    let c = {}
    c.r = r
    c.g = g
    c.b = b
    c.a = a


    return c;
}

export default function ColorPicker(props) {
    const color = props.color
    const setColor = props.setColor

    const [value, setValue] = useState(color)
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl);

    const [colorHex, setColorHex] = useState(null)

    useEffect(() => {
        setColorHex(rgbaToHex(color.r, color.g, color.b, color.a))
    }, [color])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const manualSetColor = () => {
        setColor(hexToRgba(colorHex))
    }

    const displayColor = (c) => {
        let r = parseInt(Math.round(1 - c.r) * 255)
        let g = parseInt(Math.round(1 - c.g) * 255)
        let b = parseInt(Math.round(1 - c.b) * 255)

        return `rgb(${r} ${g} ${b})`
    }

    return (
        <>
            <div className='d-flex' style={{ width: '100%' }}>
                <div className="d-flex justify-content-center align-items-center"
                    style={{
                        width: '30px', height: '30px', borderRadius: '5px',
                        border: 'solid 0.5px #DADADA',
                        //color: displayColor(color),
                        background: `rgb(${color.r} ${color.g} ${color.b})`
                    }}
                    onClick={handleClick}
                >

                </div>
                <div className='d-flex justify-content-center align-items-center'
                    style={{ width: 'calc(100% - 30px)', height: '30px', border: 'solid 0.5px #DADADA', marginLeft: '5px', borderRadius: '5px', }}> 
                    {rgbaToHex(color.r, color.g, color.b, color.a)}
                    </div>
            </div>
            <Menu anchorEl={anchorEl}
                open={open}
                onClose={handleClose}>
                <MenuItem disableRipple>
                    <div>
                        <RgbaColorPicker color={color} onChange={setColor}
                            style={{ marginBottom: '10px' }} />

                        {colorHex &&
                            <InputGroup size="sm">
                                <Form.Control value={colorHex}
                                    onChange={e => setColorHex(e.target.value)}
                                />
                                <Button onClick={manualSetColor} variant="outline-secondary">Set</Button>
                            </InputGroup>
                        }
                    </div>

                </MenuItem>
            </Menu>
        </>
    )
}

